import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import type { TourDocumentView } from 'entities/tour/models/document'
import { ManagerContacts } from 'entities/tour/ui/manager-contacts'

import { openExternalUrl } from 'shared/lib/external-open'

import common from '../../styles.module.scss'

interface Props {
  document: TourDocumentView
}

export const ManagerCard: FC<Props> = ({ document }) => {
  const { t } = useTranslation()

  const { manager } = document
  const hasContacts = Boolean(
    manager.whatsappUrl || manager.telegramUrl || manager.phone,
  )

  if (!manager.name && !hasContacts) return null

  return (
    <section className={common.card}>
      {manager.name && (
        <div>
          <h2 className="bold-16">{manager.name}</h2>
          <p className={clsx(common.caption, 'regular-14')}>
            {t('tourDetails.manager')}
          </p>
        </div>
      )}
      <ManagerContacts
        variant="details"
        callLabel={
          manager.phone ? t('tourDetails.call', { phone: manager.phone }) : ''
        }
        showWhatsApp={Boolean(manager.whatsappUrl)}
        showTelegram={Boolean(manager.telegramUrl)}
        showCall={Boolean(manager.phone)}
        onWhatsApp={() => openExternalUrl(manager.whatsappUrl ?? undefined)}
        onTelegram={() => openExternalUrl(manager.telegramUrl ?? undefined)}
        onCall={() =>
          openExternalUrl(manager.phone ? `tel:${manager.phone}` : undefined)
        }
      />
    </section>
  )
}
